"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abbr = abbr;
function abbr(str, maxLength = 55, divider = `[...]`) {
    if (str !== `${str}`) {
        return str;
    }
    let abbreviated = str;
    if (abbreviated.length > maxLength) {
        const firstLen = Math.ceil((maxLength - divider.length) / 2);
        const lastLen = Math.floor((maxLength - divider.length) / 2);
        abbreviated = `${abbreviated.slice(0, firstLen)}${divider}${abbreviated.slice(-lastLen)}`;
    }
    return abbreviated;
}
//# sourceMappingURL=abbr.js.map